module.exports = __webpack_public_path__ + "img/hr-pipe-straight-vertical-window.daba8f51.png";